import React from "react";
import { Typography } from "antd";

import "./styles.scss";
import {
  ADAPTABILITY_USPS_ICON,
  AMBITION_USPS_ICON,
  ENVIRONMENT_ICON,
  FULL_TRUST_ICON,
} from "../../constants/svgs";
import { UspType } from "../../constants/content/shared/values";

const { Title, Text } = Typography;

interface UspProps {
  type?: UspType;
  title?: string;
  description?: string;
}

const Usp: React.FC<UspProps> = ({ type = "trust", title, description }) => {
  const getIcon = () => {
    switch (type) {
      case "ambition":
        return AMBITION_USPS_ICON;
      case "adaptability":
        return ADAPTABILITY_USPS_ICON;
      case "enjoyment":
        return ENVIRONMENT_ICON;
      case "trust":
      default:
        return FULL_TRUST_ICON;
    }
  };

  return (
    <div className="Usp">
      <div className="Usp-title-container">
        {getIcon()}
        <Title className="Usp-title">{title}</Title>
      </div>
      <Text className="Usp-description">{description}</Text>
    </div>
  );
};

export default Usp;
